import React from "react";
import { useState } from "react";
import { useHistory } from "react-router";
import { Form, Input, Button, Checkbox, Row, Col } from "antd";
import { LockOutlined, CloseOutlined, MailOutlined } from "@ant-design/icons";
import {
  Container,
  InfoSection,
  InfoSectionImg,
  Title,
  TitleHead,
  TitleInfo,
  ActivitySection,
  ActvtySecWrapper,
  ActvtySecTitle,
  AlertMessageContainer,
  AlertMessage,
  AlertMessageContent,
  IconContainer,
  InfoSectionFig,
} from "../../Styles";
import fire from "../../fire";
import image from "../../assets/images/login.svg";

function Login() {
  const [errorMessage, seterrorMessage] = useState("");
  const history = useHistory();

  const onFinish = (values: any) => {
    // console.log("Received values of form: ", values);
    fire
      .auth()
      .signInWithEmailAndPassword(values.email, values.password)
      .then((userCredential) => {
        // Signed in
        var user = userCredential.user;
        // ...
        history.push("/DashBoard");
      })
      .catch((error) => {
        // console.log(error.code);
        // console.log(error.message);
        if (error.code == "auth/user-not-found") {
          seterrorMessage("invalid Email or Password");
        } else {
          seterrorMessage(error.message);
        }
      });
  };

  return (
    <Container>
      <InfoSection>
        <InfoSectionFig>
          {" "}
          <InfoSectionImg src={image} />
        </InfoSectionFig>

        <Title>
          <TitleHead>Some title goes here</TitleHead>
          <TitleInfo>
            Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
            sint. Velit officia consequat duis enim velit mollit. Exercitation
            veniam consequat sunt nostrud amet.
          </TitleInfo>
        </Title>
      </InfoSection>
      <ActivitySection>
        <ActvtySecWrapper>
          <ActvtySecTitle>Log in to your account</ActvtySecTitle>
          {errorMessage && (
            <AlertMessageContainer>
              <AlertMessage>
                <AlertMessageContent>{errorMessage}</AlertMessageContent>
                <IconContainer>
                  <CloseOutlined onClick={() => seterrorMessage("")} />
                </IconContainer>
              </AlertMessage>
            </AlertMessageContainer>
          )}
          <Form
            name="normal_login"
            className="login-form"
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
          >
            <Form.Item
              name="email"
              rules={[
                {
                  required: true,
                  message: "Please Enter Your Email ID!",
                },
                {
                  type: "email",
                  message: "This is not valid E-mail!",
                },
                {
                  pattern: /[@]/g,
                  message: "An Email Address Must Contain a Single @!",
                },
              ]}
            >
              <Input
                style={{ fontFamily: "Montserrat" }}
                prefix={<MailOutlined className="site-form-item-icon" />}
                placeholder="user@gmail.com"
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please Enter Your Password!",
                },
                {
                  pattern:
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/g,
                  message: "Password must contain atleast 8 characters",
                },
                {
                  pattern: /[0-9]{1,}/g,
                  message: "Password must contain atleast 1 number",
                },
                {
                  pattern: /[A-Z]{1,}/g,
                  message:
                    "Password must contain atleast 1 letter in capital case",
                },
                {
                  pattern: /[a-z]{1,}/g,
                  message:
                    "Password must contain atleast 1 letter in small case",
                },
                {
                  pattern: /[^A-Z0-9a-z]{1,}/g,
                  message: "Must contain atleast 1 special character",
                },
              ]}
            >
              <Input.Password
                style={{ fontFamily: "Montserrat" }}
                prefix={<LockOutlined className="site-form-item-icon" />}
                type="password"
                placeholder="Password"
              />
            </Form.Item>
            <Row gutter={24} style={{ paddingBottom: "15px" }}>
              <Col span={8}>
                <Form.Item name="remember" valuePropName="checked" noStyle>
                  <Checkbox>Remember me</Checkbox>
                </Form.Item>
              </Col>
              <Col span={8}></Col>{" "}
              <Col span={8}>
                <a
                  className="login-form-forgot"
                  onClick={() => {
                    history.push("/forgotPass");
                  }}
                >
                  Forgot password
                </a>
              </Col>
            </Row>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button loginButton"
              >
                Log in
              </Button>
              <p>
                {" "}
                Or{" "}
                <a
                  onClick={() => {
                    history.push("/sign-up");
                  }}
                >
                  register now!
                </a>
              </p>
            </Form.Item>
          </Form>
        </ActvtySecWrapper>
      </ActivitySection>
    </Container>
  );
}

export default Login;
